// Phase 3B.2.a — lightweight shared context + provenance helpers (frontend-only, no collection).
import { continentForCountryName } from "@/lib/continents";

// Common market context derived ONLY from the existing organization profile + current selection.
export const buildMarketContext = (org = {}, selectedMarket = null, period = null) => ({
  organizationId: org.id || null,
  organizationType: org.type || null,
  geographicLevel: org.geographic_level || null,
  geographicEntity: org.geographic_entity || null,
  country: org.country || null,
  continent: continentForCountryName(org.country),
  selectedMarket,
  period,
});

// role: PRIMARY | BENCHMARK | CONTEXT | DEMO ; sourceType: client | lodge | adi | benchmark | demo
export const makeProvenance = ({ source, sourceType, geographyLevel = null, geographyEntity = null,
  period = null, role, isDemo = false, lastUpdated = null }) => ({
  source, sourceType, geographyLevel, geographyEntity, period, role, isDemo, lastUpdated,
});

export const BENCHMARK_ELIGIBLE_LEVELS = new Set(["CITY", "REGION"]);
